module.exports = new __parcel__URL__("vercel.ebe8a325.svg").toString();